import { Component, OnInit, OnDestroy, HostListener } from "@angular/core";
import { ActionService } from "./services/action.service";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { Subscription } from "rxjs";
import { Title } from "@angular/platform-browser";
import { ApplicationPool } from "./services/application.pool";
import { NavigationService } from "./services/navigation.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
  static dataService: ActionService;

  title = "Schulio Public";
  constructor(
    private router: Router,
    private dataService: ActionService,
    private titleService: Title,
    private pool: ApplicationPool,
    private nav: NavigationService
  ) {
    AppComponent.dataService = this.dataService;
    this.router.setUpLocationChangeListener();
  }

  private subscription: Subscription;
  ngOnInit() {
    this.subscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo(0, 0);
      });

    window.scrollTo(0, 0);
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  lastTitle = "Schulio Verleihsysteme";
  get Reload() {
    if (this.pool.data && this.pool.data.SelectedLibrary) {
      const title = "Schulio - " + this.pool.data.SelectedLibrary.label;
      if (this.lastTitle != title) {
        this.titleService.setTitle(title);
        this.lastTitle = title;
      }
    } else {
      if (this.lastTitle != "Schulio Verleihsysteme") {
        this.lastTitle = "Schulio Verleihsysteme";
        this.titleService.setTitle(this.lastTitle);
      }
    }
    return null;
  }

  @HostListener("window:keydown", ["$event"])
  keyEvent(event: KeyboardEvent) {
    // on keyup enter
    if (event.keyCode === 13) {
      const target = event.target as any;
      if (target.nodeName == "INPUT") {
        var form = target.closest("form");
        setTimeout(() => {
          if (form) {
            var index = Array.prototype.indexOf.call(form, event.target);
            form.elements[index + 1].focus();
            if (form.elements[index + 1].nodeName == "BUTTON") {
              form.elements[index + 1].click();
            }
            return false;
          }
        }, 100);
        event.stopImmediatePropagation();
        event.stopPropagation();
        event.preventDefault();
        return false;
      }
    }
  }

  closePopup() {
    this.router.navigateByUrl(document.location.pathname.split("(")[0]);
  }
}
